<template>
  <div class="zxybg">
     <headerBanner :bannerUrl='bannerUrl'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i1"></i></div><p>资讯与报告</p>
    </div>
    <div class="zxybg_detail">
      <div class="zxybg_item" v-for='item in data'>
        <a :href="domain+item.jumpurl">
        <div class="img_wrap">
          <img :src="domain+item.litpic" alt="">
        </div>
        <div class="zxybg_right">
          <div class="name">
            {{item.title}}
          </div>
          <div class="btn">
            查看详情
          </div>
        </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'zxxy',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      bannerUrl:''
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_lists',
       {
          cid:4
        },
       {emulateJSON : true})
   .then((response) => {
         this.data=response.body.data;
         this.bannerUrl = this.domain+response.body.bgpic
         console.log(response)
         
     })
  }
}
</script>

<style scoped>
  i.i1{
    width: 0.38rem;
    height: 0.37rem;
    background-image: url(../../static/images/i2.png);
    background-size: 0.38rem 0.37rem;
  }
  .zxybg_detail{
    padding: 0 0.36rem 0 0.4rem;
    
  }
  .zxybg_item{
    padding-bottom: 0.22rem;
    border-bottom: 1px dashed #757679;
    margin-bottom: 0.28rem;
  }
  .zxybg_item .img_wrap{
    display: inline-block;
  }
  .zxybg_item img{
    width: 1.32rem;
    display: block;
  }
  .zxybg_right{
    width: 4.1rem;
    font-size: 0.2rem;
    display: inline-block;
    margin-left: 0.16rem;
  }
  .zxybg_right .name{
    color: #000;
  }
  .zxybg_right .btn{
    color: #336699;
    text-decoration: underline;
  }
</style>


// WEBPACK FOOTER //
// src/components/zxybg.vue